import React from 'react';

export default function BlogPage() {
  return (
    <div className="bg-slate-50 min-h-screen py-16 animate-fade-in font-sans">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-xs font-bold uppercase tracking-wider text-blue-600">Our Blog</span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight leading-none mt-2 mb-4">
            Latest Updates
          </h1>
          <p className="text-slate-600 text-sm">
            Insights on vibe coding, data warehousing, and the future of ETL.
          </p>
        </div>

        <article className="bg-white rounded-3xl p-8 border border-slate-200/60 shadow-sm mb-8">
          <header className="mb-6">
            <span className="text-xs font-bold text-blue-600 bg-blue-50 px-2.5 py-1 rounded-full uppercase tracking-wider">
              Product Update
            </span>
            <h2 className="text-2xl font-bold text-slate-950 mt-3 mb-2">
              Stop Coding, Start Vibe Coding: Meet Candor
            </h2>
            <p className="text-slate-400 text-xs">Published June 4, 2026</p>
          </header>

          <div className="text-slate-700 text-sm leading-relaxed space-y-4">
            <h3 className="text-slate-900 font-bold text-md pt-2">The Problem We All Face</h3>
            <p>
              Generalist tools write code blindly. If they generate a script using STRING instead of NVARCHAR or mismatch a foreign key, your execution crashes, trapping you in a token debugging loop.
            </p>
            
            <h3 className="text-slate-900 font-bold text-md pt-2">A New Approach: From Coding to Vibe Coding</h3>
            <p>
              Candor reads your data model before generating code. By introspecting tables, data types, and structural constraints, it eliminates type mismatch errors. You get flawless, 1-shot execution.
            </p>

            <h3 className="text-slate-900 font-bold text-md pt-2">Introducing Candor</h3>
            <p>
              Candor is our flagship data platform, bringing together AI-driven pipeline creation, cognitive analytics, and developer-focused tooling into a single unified workspace.
            </p>

            <h3 className="text-slate-900 font-bold text-md pt-2">How It Works</h3>
            <ol className="list-decimal pl-4 space-y-2 text-xs sm:text-sm">
              <li><strong>Natural Language Prompt:</strong> Describe your pipeline intent in plain English.</li>
              <li><strong>Agentic AI Core:</strong> Introspects active schemas and creates optimized Python code.</li>
              <li><strong>Pipeline Orchestration:</strong> Validates and runs the pipeline securely.</li>
            </ol>
          </div>
        </article>
      </div>
    </div>
  );
}
